import * as React from "react";
function SvgIcPrevious(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 20.256V3.744l-7.83 7.512V3H6v18h4.17v-8.256L18 20.256zM9 20V4H7v16h2zm1.838-8L17 17.91V6.09L10.838 12z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcPrevious;
